<div mat-dialog-title class="modal-title">
  <mat-icon>attach_money</mat-icon>
  <span>Pagar al afiliado</span>
  <mat-icon class="close-button" (click)="confirmCloseModal()"> cancel </mat-icon>
</div>
<mat-dialog-content>
  <form [formGroup]="paymentForm">
    <div class="form-control">
      <mat-form-field appearance="outline" color="primary">
        <mat-label>Total pagado</mat-label>
        <input matInput type="number" placeholder="Total pagado" formControlName="totalPaid" name="totalPaid" autocomplete="off" />
        <mat-error> Mínimo cero </mat-error>
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button color="primary" (click)="confirmCloseModal()"> Cerrar </button>
  <button mat-flat-button color="primary" (click)="payToAffiliatePayment()" [disabled]="paymentForm.invalid || isUpdatingPayment">
    @if (!isUpdatingPayment) {
      <span>Guardar</span>
    } @else {
      <mat-spinner class="white-spinner"></mat-spinner>
    }
  </button>
</mat-dialog-actions>
